import React, { useState } from "react";
import EsquinerosArriba from "../components/EsquinerosArriba";
import EsquinerosAbajo from "../components/EsquinerosAbajo";

export default function MensajeCentral() {
  const [fontSizes, setFontSizes] = useState(16)

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize)
    }
  }
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize)
    }
  }
  return (
    <>
      <div style={{ paddingTop: '3.25rem' }}>
        <EsquinerosArriba />
      </div>
      <div className="container">
        <div id="mensajes-body" className={'font-' + fontSizes}>
          <div className="row">
            <div className="col-12 px-4">
              <p>
                <strong>1 -</strong> Volver a amar el Divino Corazón Eucarístico
                de Jesús. Adorar perpetuamente en reparación al Corazón
                Eucarístico vivo y presente entre nosotros en la Sagrada
                Eucaristía.
              </p>
              <br />
              <p>
                <strong>2 -</strong> La Evangelización y Consagración del mundo
                entero al Corazón Eucarístico de Jesús y al Inmaculado Corazón
                de María.
              </p>
              <br />
              <p>(En un mensaje privado)</p> <br />
              <p>

                .....Seguid predicando mis mensajes y especialmente la devoción
                al <strong>SACRATISIMO CORAZON EUCARISTICO DE JESUS</strong>, no
                ceséis en este empeño, que cada alma se Consagre a Él, y así
                todos recibirán la Infinita Misericordia de su Corazón. Predicad
                su Consagración, avisando que toda alma a El consagrada,
                recibirá todas las Gracias que brotan de la Divina Misericordia
                del Señor. Esta Consagración, al
                <strong>Sacratísimo Corazón Eucarístico de Jesús</strong> tendrá
                el sello de Eternidad en las almas y obrará un cambio grande en
                ellas. Será la llave que abrirá el alma para su
                <strong>Conversión</strong>.
              </p>
              <br />
              <p>
                <strong>3 -</strong> La unión de Occidente y Oriente.
              </p>
              <br />
              <p>
                <strong>4 -</strong> La preparación para la segunda venida de
                Nuestro Señor Jesucristo. Que consiste en un mayor conocimiento
                del Amor de Dios.
              </p>
              <br />
              <p>
                <strong>5 -</strong> La esperanza, el camino que nos conduce a
                Dios.
              </p>
              <br />
              <p>
                Vivir el Amor, vivir con el Amor de su Divino Corazón, vivir un
                tiempo de eternidad.
              </p>
            </div>
          </div>
        </div>
      </div>
      <EsquinerosAbajo />
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: '1.1rem' }} >
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
